import { CSSProperties, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import api from "../Services/api";

const ComplianceCarrossel = () => {

  const [images, setImages] = useState<any[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedImageDesc, setSelectedImageDesc] = useState('');

  const openModal = (url: string, desc: string) => {
    setSelectedImage(url);
    setSelectedImageDesc(desc);
    setModalIsOpen(true);
    document.body.classList.add('modal-open');
  };

  const closeModal = () => {
    setSelectedImage('');
    setSelectedImageDesc('');
    setModalIsOpen(false);
    document.body.classList.remove('modal-open');
  };

  const getConfigurableProps = () => ({
    showArrows: true,
    showStatus: false,
    useKeyboardArrows: true,
    swipeable: true,
    emulateTouch: true,
    ariaLabel: '',
    showThumbs: false,
    autoPlay: true,
    infiniteLoop: true,
  });

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      background: 'transparent',
      overflow: 'visible',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  };

  const descriptionStyle: CSSProperties = {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    color: '#fff',
    textAlign: 'center',
    width: '80%',
    background: 'rgba(0, 0, 0, 0.7)',
    padding: '10px',
    borderRadius: '5px',
  };

  useEffect(() => {
    api.get("/ObterImagensCompliance").then((response) => {
      setImages(response.data.results);
    }).catch((err) => {
      console.log(err);
    }
    );
  }, []);

  return (
    <div className="container mb-10">
      {!modalIsOpen && (
        <Carousel {...getConfigurableProps()}>

          {images?.map((image, index) => (
            <div key={index} onClick={() => openModal(image.URL, image.Title)}>
              <img
                src={`${image.URL}`}
                alt={image.Title}
                style={{
                  maxWidth: '100%',
                  maxHeight: '450px',
                  objectFit: 'cover',
                  width: '100%',
                }}
              />
              {image.Title &&
                (
                  <p style={descriptionStyle}>{image.Title}</p>
                )
              }
            </div>
          ))}
        </Carousel>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Imagem Ampliada"
        style={customStyles}
        bodyOpenClassName="modal-open"
      >

        <img src={`${selectedImage}`} alt="Imagem ampliada" />
        <p style={{ color: '#fff', textAlign: 'center' }}>{selectedImageDesc}</p>
      </Modal>
    </div>
  );
};


export default ComplianceCarrossel;
